<template>
  <section class="section section--alt">
    <div class="container">
      <p class="eyebrow">{{ t("faq.eyebrow") }}</p>
      <h2 class="section-title">{{ t("faq.title") }}</h2>
      <p class="section-lead">{{ t("faq.lead") }}</p>
      <div class="faq-list">
        <details v-for="index in 6" :key="index" class="faq-item">
          <summary>{{ t(`faq.items.${index - 1}.q`) }}</summary>
          <p>{{ t(`faq.items.${index - 1}.a`) }}</p>
        </details>
      </div>
    </div>
  </section>
</template>

<script>
import { useI18n } from "vue-i18n";

export default {
  name: "FaqSection",
  setup() {
    const { t } = useI18n();
    return { t };
  },
};
</script>
